import { render, staticRenderFns } from "./links-form.vue?vue&type=template&id=5b644e68&scoped=true&"
import script from "./links-form.vue?vue&type=script&lang=ts&"
export * from "./links-form.vue?vue&type=script&lang=ts&"
import style0 from "./links-form.vue?vue&type=style&index=0&id=5b644e68&lang=scss&scoped=true&"
import style1 from "./links-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b644e68",
  null
  
)

export default component.exports